// Client for the Hermes message-generation service. Requests are authorized
// with a short-lived JWT minted by the backend per organization.

import { toSnakeCase } from 'case-converter';
import { v4 as uuid } from 'uuid';

import { getSessionId } from 'utils/analytics';
import request from 'utils/request';

export const isHermesConfigured = () => Boolean(process.env.REACT_APP_HERMES_URL);

export const fetchHermesToken = async organizationUuid => {
  const { data } = await request.post('/v1/campaigns/hermes-jwt/', {
    organization: organizationUuid,
  });

  return data.token;
};

// Returns an array of generated messages, camelCased by the shared response
// interceptor. Body items come back without uuids; callers must assign them.
export const generateSimilarMessages = async ({
  actionCenterDescription,
  actionCenterTitle,
  count = 1,
  messages,
  token,
}) => {
  const { data } = await request.post(
    '/genx/duplicate-messages',
    // The request interceptor skips snake_casing for external hosts.
    toSnakeCase({
      actionCenterDescription,
      actionCenterTitle,
      count,
      messages: messages.map(({ body, isAllowPersonalMessage, subject, uuid: messageUuid }) => ({
        body: body.map(({ isAllowEdit, name }) => ({ isAllowEdit, name })),
        isAllowPersonalMessage,
        subject: { isAllowEdit: subject.isAllowEdit, name: subject.name },
        uuid: messageUuid,
      })),
    }),
    {
      baseURL: process.env.REACT_APP_HERMES_URL,
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Session-Id': getSessionId(),
        'X-Trace-Id': uuid(),
      },
      withCredentials: false,
    }
  );

  return data;
};
